import {CommandName} from "./command-name.enum";
import {AbstractCommand} from "./abstract.command";

export class OpenNewIssueTypeDialogCommand extends AbstractCommand<void> {

    public name: CommandName = CommandName.OPEN_NEW_ISSUE_TYPE_DIALOG;

    public tags = ['ui', 'dialog', 'issue-type', 'create'];

    constructor() {
        super('issue-type', 'new', undefined);
    }
}